export const FETCHED_CONSUMPTIONS = "FETCHED_CONSUMPTIONS";
export const RECEIVED_CONSUMPTIONS = "RECEIVED_CONSUMPTIONS";
